(function(){
  function positionDots(){
    var cart = document.querySelector('.header-icons-group__cart, [href*="/cart"], .cart-icon, .icon-cart');
    var dots = document.querySelector('[data-section-name="announcement-bar-header"] .swiper-pagination');
    var bar = document.querySelector('[data-section-name="announcement-bar-header"]');
    if(!cart || !dots || !bar) return;
    var cartRect = cart.getBoundingClientRect();
    var barRect = bar.getBoundingClientRect();
    // Hide dots if announcement bar is scrolled out of view
    if(barRect.bottom < 0) {
      dots.style.display = 'none';
      return;
    }
    var topPos = Math.max(barRect.top + barRect.height/2, barRect.height/2);
    dots.style.cssText = 'position:fixed!important;right:'+(window.innerWidth - cartRect.right + (cartRect.width/2) + 35)+'px!important;top:'+topPos+'px!important;left:auto!important;width:auto!important;display:flex!important;gap:5px!important;z-index:999999!important;transform:none!important;';
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){setTimeout(positionDots,100);});
  }else{
    setTimeout(positionDots,100);
  }
  window.addEventListener('resize',positionDots);
  window.addEventListener('scroll',positionDots);
})();

/* Flicker fix - adds delay before collapsing product card icon buttons */
(function() {
  function initFlickerFix() {
    var buttons = document.querySelectorAll('.product-card__media-buttons__item');
    buttons.forEach(function(btn) {
      if (btn.dataset.flickerFixApplied) return;
      btn.dataset.flickerFixApplied = 'true';
      var timeout;
      btn.addEventListener('mouseenter', function() {
        clearTimeout(timeout);
        this.classList.add('is-hovered');
      });
      btn.addEventListener('mouseleave', function() {
        var self = this;
        timeout = setTimeout(function() {
          self.classList.remove('is-hovered');
        }, 100);
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', initFlickerFix);
  } else {
    initFlickerFix();
  }

  // Re-init for dynamically loaded content (wishlist, ajax, etc)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(initFlickerFix, 100);
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
